import $ from 'jquery';
import {
	HashRouter,
	BrowserRouter as Router,
	Route,
	IndexRoute,
	Switch,
} from 'react-router-dom';
import zhCN from 'antd/lib/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import 'antd/dist/antd.css';
import {
	ConfigProvider,
	Spin,
} from 'antd';

import BaseClass from '@/pages/BaseClass';
import '@/assets/css/style.scss';
import '@/assets/css/font-awesome.min.css';

//import Index from '@/pages/Index';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import FindPassword from '@/pages/FindPassword';
import Article from '@/pages/Article';
import ImageList from '@/pages/ImageList';
import AddOrder from '@/pages/AddOrder';
import GoodsList from '@/pages/GoodsList';
import Goods from '@/pages/Goods';
import Order from '@/pages/Order';
import Package from '@/pages/Package';
import User from '@/pages/User';
import Scan from '@/pages/Scan';

import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost,
	getQuery,
} from '@/utils/Tools';

moment.locale('zh-cn');
export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'isLoading':false,
			'loadingNode':'',
			
			'isLogin':false,
			
			'navIndex':-1,
			'navIndex1':-1,
			'showWechatQr':false,
			
			'userInfo':{},
			'navList':[],
			'footLinkList':[],
			'configList':{},
			'siteIds':{},
			'siteName':'',
			'siteUrl':'',
			'hideLayout':false,
		};
		
		global.setRootState=this.setRootState.bind(this);
		global.getRootState=this.getRootState.bind(this);
	}
	
	componentDidMount()
	{
		let userInfo = CommonValue.get('user_info');
		if(userInfo)
			this.setState({
				'userInfo':userInfo
			});
		
		let url = pcUrl('index','index');
		httpPost(url)
			.then(data=>{
				CommonValue.set('site_name',data['site_name']);
				CommonValue.set('site_url',data['site_url']);
				this.setState({
					'navList':data['nav_list'],
					'footLinkList':data['foot_link_list'],
					'configList':data['config_list'],
					'siteIds':data['site_ids'],
					'siteName':data['site_name'],
					'siteUrl':data['site_url'],
				},()=>{
					this.navInit();
				});
			});

		let currentUrl = window.location.href;
		currentUrl = currentUrl.split('?')[0];
		let pathname = currentUrl.split('#')[1];
		let query = getQuery();
		this.navIndexInit(pathname,query);
		window.addEventListener('hashchange',(e)=>{
			let pathname = window.location.href.split('#')[1];
			let query = getQuery();
			this.navIndexInit(pathname,query);
		});
	}
	
	navIndexInit(pathname,query)
	{
		console.log(pathname,query);
		let navIndex = -1;
		let navIndex1 = -1;
		if(pathname.indexOf('/imageList') === 0)
		{
			let type = query.type;
			if(!type) type = 0;
			if(0 == type)
				navIndex = 1;
			else if(2 == type)
				navIndex = 2;
		}
		else if( pathname.indexOf('/goods') === 0)
		{
			navIndex = 3;
			/*
			if( query.id == 5 )
				navIndex1 = 0;
			else if( query.id == 6 )
				navIndex1 = 1;
			else if( query.id == 7 )
				navIndex1 = 2;
			else if( query.id == 8 )
				navIndex1 = 3;
			else if( query.id == 9 )
				navIndex1 = 4;
			else if( query.id == 10 )
				navIndex1 = 5;
			*/
		}
		/*
		else if('/user/charge' == pathname)
			navIndex = 5;
		else if( pathname.indexOf('/order') === 0)
			navIndex = -10;
		*/
		else if( pathname == '/' || pathname.indexOf('/login') === 0)
			navIndex = -20;
		else if( pathname.indexOf('/findPassword') === 0)
			navIndex = -20;
		else if( pathname.indexOf('/register') === 0)
			navIndex = -30;
			
		this.setState({
			'navIndex':navIndex,
			'navIndex1':navIndex1,
		});
		
	}
	navInit()
	{
		/*
		$('.new-head').find('.nav ul li').on('mouseover',function(){
			if($(this).find('.submenu').css('display')=='none')
				$(this).find('.submenu').slideDown(200);
		});
		$('.new-head').find('.nav ul li').on('mouseout',function(){
			if($(this).find('.submenu').css('display')=='block')
				$(this).find('.submenu').slideUp(100);
		});
		*/
		$('.new-head').find('.nav ul li').hover(function(){
			if($(this).find('.submenu').css('display')=='none')
				$(this).find('.submenu').slideDown(200);
		},function(){
			if($(this).find('.submenu').css('display')=='block')
				$(this).find('.submenu').slideUp(100);
		});
	}
	
	setRootState(data)
	{
		return new Promise((resolve,reject)=>{
			for(let i in data)
			{
				if(this.state[i] === undefined)
					delete(data[i]);
				else
				{
					this.state[i] = data[i];
				}
			}
			
			this.setState(data,resolve);
		});
	}
	
	getRootState(key)
	{
		return this.state[key];
	}
	
	logout()
	{
		let url = pcUrl('index','logout');
		httpPost(url)
			.then(()=>{
				CommonValue.set('user_info','');
				this.setState({
					'userInfo':{},
				});
				window.location.href = ngUrl('login');
			});
	}
	
	render()
	{
		return (
			<ConfigProvider locale={zhCN}>
				<Spin indicator={this.state.loadingNode} wrapperClassName="spin-ajax" spinning={this.state.isLoading}>
					{this.state.hideLayout || (
						<div className={[-20,-30].includes(this.state.navIndex)?['new-head','no-hover',this.state.navIndex == -30 ? 'normal-head':''].join(' ') : ["new-head","white-bg","normal-head"].join(' ')}>
							<div className="body">
								<div>
									<div className="float-right" style={{'display':[-20,-30].includes(this.state.navIndex)?'none':'block'}}>
										{!this.state.userInfo['user_id'] ? (
										<>
											<a href="javascript:;">
												<span className="clips member-ico"></span>
											</a>
											<div className="dropdown">
												<a href={ngUrl('login')}> 立即登录 </a>
												<a href={ngUrl('register')}> 立即注册 </a>
												<a href={ngUrl('user','order')}> 我的订单 </a>
												<a href={ngUrl('user')}> 个人中心 </a>
											</div>
										</>
										):(
										<>
											<a href="javascript:;">
												<img src={this.state.userInfo['rank_avatar'] || require('@/assets/images/avatar.png')} />
											</a>
											<div className="dropdown">
												<a href={ngUrl('user','order')}> 我的订单 </a>
												<a href={ngUrl('user')}> 个人中心 </a>
												<a href={ngUrl('user','chargeEvent')}> 活动充值 </a>
												<a href="javascript:;" onClick={()=>this.logout()}> 退出登录 </a>
											</div>
										</>
										)}
									</div>
									<div className={["logo",[-20,-30].includes(this.state.navIndex)?'logo-1':''].join(' ')}>
										<h1>
											<a href={this.state.siteUrl}>{this.state.siteName}</a>
										</h1>
									</div>
									<div className="nav" style={{'display':[-20,-30].includes(this.state.navIndex)?'none':'block'}}>
										<ul>
											<li> <a href={this.state.siteUrl}>首页</a> </li>
											{this.state.navList.map((row,index)=>(
												<li>
													<a href={row['url']} className={index+1 == this.state.navIndex ?'now':''}> {row['nav_name']} </a>
													{row['child_list'] && row['child_list'].length ? (
														<div className="submenu">
															<div className="body">
																<ul>
																	{row['child_list'].map((row1,index1)=>(
																		<li>
																			<a href={row1['url']} className={(index+1 == this.state.navIndex && index1 == this.state.navIndex1) ?'now':''}>
																				<img src={row1['nav_thumb']} />
																				<br />
																				{row1['nav_name']}
																			</a>
																		</li>
																	))}
																</ul>
															</div>
														</div>
													):''}
												</li>
											))}
										</ul>
									</div>
									<div className="clear"></div>
								</div>
							</div>
						</div>
					)}
					<HashRouter>
						<Switch>
							<Route exact path="/" component={Login} />
							<Route path="/login" component={Login} />
							<Route path="/register" component={Register} />
							<Route path="/findPassword" component={FindPassword} />
							<Route path="/article" component={Article} />
							<Route path="/imageList" component={ImageList} />
							<Route path="/addOrder" component={AddOrder} />
							<Route path="/goodsList" component={GoodsList} />
							<Route path="/goods/:id" component={Goods} />
							<Route path="/user" component={User} />
							<Route path="/scan" component={Scan} />
							<Route path="/order/:id" component={Order} />
							<Route path="/package/:id" component={Package} />
						</Switch>
					</HashRouter>
					{this.state.hideLayout || (
						<div className="new-foot">
							<div className="body">
								{![-20,-30].includes(this.state.navIndex) && (
									<div className="foot-1">
										<div className="foot-1-2">
											<dl className="foot-1-2-1">
												<dd>周一至周日 8:30-23:00</dd>
												<dt className="text-blue">
													{this.state.configList['tel_number']}
												</dt>
											</dl>
											<dl className="foot-1-2-2">
												<dd>
													<img src={this.state.configList['wechat_qr']} />
												</dd>
												<dt>
													官方微信
													<br />
													(可供查单、报价、售后)
												</dt>
											</dl>
										</div>
										<div className="foot-1-1">
											<dl>
												<dd>
													<span className="clips foot-new-ico-1"></span>
												</dd>
												<dt>
													先进设备
												</dt>
												<dd className="desc">
													Advanced equipment
												</dd>
											</dl>
											<dl>
												<dd>
													<span className="clips foot-new-ico-3"></span>
												</dd>
												<dt>
													色彩管理
												</dt>
												<dd className="desc">
													Color Management
												</dd>
											</dl>
											<dl>
												<dd>
													<span className="clips foot-new-ico-2"></span>
												</dd>
												<dt>
													专业团队
												</dt>
												<dd className="desc">
													Professional Team
												</dd>
											</dl>
											<dl>
												<dd>
													<span className="clips foot-new-ico-4"></span>
												</dd>
												<dt>
													千款产品
												</dt>
												<dd className="desc">
													Thousands of products
												</dd>
											</dl>
										</div>
										<div className="clear"></div>
									</div>
								)}
								<div className="foot-2">
									<p>
										{this.state.footLinkList.map((row,index)=>(
										<a href={"/article/detail/id/"+row['article_id']} className={[index==0?'first':'',index == this.state.footLinkList.length - 1 ? 'spec':''].join(' ')}>{row['title']}</a>
										))}
									</p>
									<p>
										Copyright©2022{this.state.configList['power_name']} 版权所有
										&nbsp;&nbsp;&nbsp;
										备案号：
										<a href="https://beian.miit.gov.cn/" target="_blank"> {this.state.configList['icp_number']} </a>
									</p>
								</div>
							</div>
						</div>
					)}
				</Spin>
			</ConfigProvider>
		);
	}
};
